class TokenGeneratorService extends BaseService
	@register()
	@inject 'AuthenticationRepository', 'ENV'

	getToken: (register) ->
		ucfirst = (input) => (input && input[0].toUpperCase() + input.slice(1)) || ''

		return @AuthenticationRepository
			.getLoginToken register.id
			.then (authToken) =>
				environment = @ENV.environment
				prefix = 'wallmob'

				if environment != 'etail' || environment != 'prod'
					prefix += '-test'

				tenant = @ENV.tenant

				if tenant == 'infra'
					tenant = 'wallmob'

				environmentName = ucfirst(tenant) + ' ' + ucfirst(@ENV.tenant)

				url = new URL("#{prefix}://autologin")
				url.searchParams.append('auth_token', authToken.access_token)
				url.searchParams.append('shop_id', register.shop_id)
				url.searchParams.append('register_id', register.id)
				url.searchParams.append('env', "#{tenant}-#{environment}")
				url.searchParams.append('env_name', environmentName)

				return url.toString()
